import {
  UserToken as UserTokenDomainModeType,
  IUser as IUserDomainModelType
} from '../models/user';
export type UserToken = UserTokenDomainModeType;

export type IUser = IUserDomainModelType;

export const author1: IUser = {
  id: '3d34f57e-9798-4c83-b0a5-ba7516f371d7',
  firstName: 'A.Matthew',
  lastName: 'Lewis',
  email: 'lewis.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};

const author1PreProd: IUser = {
  ...author1,
  id: '8fc6a9d1-212b-449a-9b86-5f94688d2456'
};

const editor1: IUser = {
  id: '8713c500-a9fa-45b3-aba1-4b1f59832ad0',
  firstName: 'A.Aiden',
  lastName: 'Cruz',
  email: 'aiden.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};

const editor1PreProd: IUser = {
  ...editor1,
  id: 'bba8d6a2-8917-4d9b-a335-506f291fe1ae'
};

const editor2: IUser = {
  id: 'f3c5aa62-5384-48ca-92ed-58ed4ab4c578',
  firstName: 'C.Charlotte',
  lastName: 'Davis',
  email: 'charlotte.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};
const editor2PreProd: IUser = {
  ...editor2,
  id: '2c746449-038a-4125-a71a-6b1c1d33d1b2'
};

const editor3: IUser = {
  id: '83ab8aac-290a-49b3-8b95-f6327fd7c3d8',
  firstName: 'S.Simon',
  lastName: 'Clarke',
  email: 'simon.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};
const editor3PreProd: IUser = {
  ...editor3,
  id: 'ee65ea73-2535-4f49-aeb8-13b0a6038de8'
};

const reviewer1: IUser = {
  id: 'ed1f7802-d775-4b8f-a602-1a8b80f2c6a8',
  firstName: 'R.John',
  lastName: 'Doe',
  email: 'doe.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};

const reviewer1PreProd: IUser = {
  ...reviewer1,
  id: '7beb8fd4-7da0-4fc4-9d6b-9676b9ac5864'
};

const reviewer2: IUser = {
  id: '8a515fff-1f21-42b2-ba39-dfb67e4af6d1',
  firstName: 'R.Monalisa',
  lastName: 'Paine',
  email: 'paine.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};

const reviewer2PreProd: IUser = {
  ...reviewer2,
  id: 'b906f751-308f-4b3a-b0b8-e30a35194dea'
};

const orgAdmin1: IUser = {
  id: 'a1451151-d502-4a87-a813-c3b3135a07cc',
  firstName: 'O.Oscar',
  lastName: 'Odin',
  email: 'odin.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};

const orgAdmin1PreProd: IUser = {
  ...orgAdmin1,
  id: '2ad524dc-2127-4237-866b-86d508f37b4b'
};
const orgAdmin1Prod: IUser = {
  ...orgAdmin1,
  id: 'd48f30e2-502e-4fba-8d71-6624cd1cb378'
};

const sysAdmin1: IUser = {
  id: 'ae0aa389-950f-41a0-9564-efd462c21b36',
  firstName: 'Sudo',
  lastName: 'User',
  email: 'sudo.scup.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'scup',
  status: 'active'
};

const sysAdmin1PreProd: IUser = {
  ...sysAdmin1,
  id: 'a5b75234-177c-4ca8-9587-a09e65b0d91f'
};

const sysAdmin1Prod: IUser = {
  ...sysAdmin1,
  id: 'ed27ae37-3fbc-4fc9-95dc-ad76fdccd5f1'
};

export const STAGING_USERS_MAP = {
  author1,
  editor1,
  editor2,
  editor3,
  reviewer1,
  reviewer2,
  orgAdmin1,
  sysAdmin1
} as const;

export const PREPROD_USERS_MAP = {
  author1: author1PreProd,
  editor1: editor1PreProd,
  editor2: editor2PreProd,
  editor3: editor3PreProd,
  reviewer1: reviewer1PreProd,
  reviewer2: reviewer2PreProd,
  orgAdmin1: orgAdmin1PreProd,
  sysAdmin1: sysAdmin1PreProd
} as const;

export const PROD_USERS_MAP = {
  orgAdmin1: orgAdmin1Prod,
  sysAdmin1: sysAdmin1Prod
} as const;
